import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ApplicationService } from '@services';
import utils from '@utils';

class StateSelection extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			USStates : [],
			loading  : false,
		};
	}

	componentDidMount = () => this.getUSStates();

	getUSStates() {
		this.setState({ loading : true });

		ApplicationService.getUSStates()
			.then(({ data }) => {
				const USStates = data.map((USState) => ({
					value : USState.Id,
					label : `${USState.Abbreviation} - ${USState.Name}`,
				}));

				this.setState({ USStates, loading : false });
			})
			.catch(() => {
				utils.notify({
					type    : 'error',
					message : 'Error loading US States',
					timeOut : 1500,
				});

				this.setState({ loading : false });
			});
	}

	render() {
		const {
			value, name, className, id, onChange, onBlur, disabled,
		} = this.props;
		const { USStates, loading } = this.state;

		return (
			<select
				className={`state-select ${className || ''}`}
				id={id}
				value={value || ''}
				name={name}
				disabled={disabled}
				placeholder="Select State"
				onBlur={onBlur}
				onChange={onChange}
			>
				<option>Select State</option>
				{!loading && USStates.map(({ value : stateId, label }) => (
					<option key={`stateSelect${stateId}`} value={stateId}>{label}</option>
				))}
			</select>
		);
	}
}

StateSelection.propTypes = {
	value : PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	className : PropTypes.string,
	id        : PropTypes.string,
	name      : PropTypes.string.isRequired,
	onChange  : PropTypes.func.isRequired,
	onBlur    : PropTypes.func,
	disabled  : PropTypes.bool,
};

StateSelection.defaultProps = {
	value     : '',
	className : undefined,
	id        : undefined,
	disabled  : false,
	onBlur    : () => undefined,
};

export default StateSelection;
